export enum DynamicFieldTypes {
  STRING = 'string',
  NUMBER = 'number',
}